module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/logo-566c2ba5b5859b076483d871fec5b9ad.png";